import { SectionComponentProps } from "../../types";
import PillarBenefits from "../references/components/BenefitsDisplay";
import Section from "../../common/Section/Section";
import { Pillars } from "../../../../types";
import { buildBenefitsFields } from "../../../fields/benefits";

function Benefits({ details, onEdit }: SectionComponentProps) {
  const { pillars } = details;

  return (
    <Section
      title="Benefits"
      columns={2}
      fields={buildBenefitsFields(pillars)}
      onEdit={() => onEdit("benefits")}
      reference={[
        {
          type: "component",
          place: "beneath",
          index: 0,
          item: <PillarBenefits pillars={pillars as Pillars} />,
        },
      ]}
    />
  );
}

export default Benefits;
